/**
 * Filtre les caractères spéciaux pour prénom/nom.
 * Autorise uniquement : lettres (y compris accentuées), espaces, tirets.
 */
export const sanitizeNameInput = (value) => {
  if (typeof value !== 'string') return '';
  return value.replace(/[^\p{L}\s\-]/gu, '');
};
